<template>
	<div class="vip_page widthCen ">
		<div class="head_bai flex float">
			<div class="head_left">
				<div class="head_img" style="overflow: hidden;">
					<img :src="imgUrl" style="transition: all 0.3s;" />
				</div>
				<ul class="flex aa">
					<li :class="isTou===index?'ona':''" v-for="(item, index) in currCard.PcPictureUrls" :key="index"
						class="head_ddimg shou" @click="imgItem(item,index)">
						<img :src="item" />
					</li>
				</ul>
				<!-- <swiper class=" gallery-top" :options="swiperOptionTop" ref="swiperTop">
					<swiper-slide class="swiper-slide head_img" v-for="(item, index) in currCard.PcPictureUrls"
						:key="index"><img :src="item" /></swiper-slide>
					<div class="swiper-button-next swiper-button-white" slot="button-next"></div>
					<div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
				</swiper>
				<swiper class=" gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
					<swiper-slide class="swiper-slide head_ddimg shou" v-for="(item, index) in currCard.PcPictureUrls">
						<img :src="item" /></swiper-slide>
				</swiper> -->
			</div>

			<div class="head_you">
				<div class="head_tab flex wrap">
					<p v-for="(item,index) in cardList" :key="index" :class="item.Id == currCard.Id ? 'on' : ''"
						@click="onTab(index)">{{item.Name}}</p>
					<!-- <p :class="isTab == 1 ? 'on' : ''" @click="onTab(1)">新高考VIP卡</p>
                    <p :class="isTab == 2 ? 'on' : ''" @click="onTab(2)">升学规划VIP卡</p>
                    <p :class="isTab == 3 ? 'on' : ''" @click="onTab(3)">学业规划VIP卡</p>
                    <p :class="isTab == 4 ? 'on' : ''" @click="onTab(4)">高效查VIP卡</p>
                    <p :class="isTab == 5 ? 'on' : ''" @click="onTab(5)">精准填VIP卡</p>
                    <p :class="isTab == 6 ? 'on' : ''" @click="onTab(6)">学情管理VIP卡</p>
                    <p :class="isTab == 7 ? 'on' : ''" @click="onTab(7)">家长测评VIP卡</p> -->
				</div>
				<div class="head_yqian flex zhong">
					<span>价格</span>
					<h6>
						￥{{currCard.Price||''}}
						<span>原价:￥{{currCard.OldPriceStr||''}}</span>
					</h6>
				</div>
				<div class="head_red">{{currCard.Introduce}}</div>
				<div class="head_btn flex">
					<div class="hea_an flexCenter shou" @click="vipPay()">立即购买</div>
					<div class="hea_an flexCenter shou">
						<img src="../../image/san/call.png" />
						咨询热线:{{currCard.PhoneLine||''}}
					</div>
				</div>
				<div class="head_ytxt" v-html="currCard.Info"></div>
			</div>
		</div>

		<div class="bai_b">
			<h6>服务详情</h6>
			<div class="bai_txt fwbhtml" v-html="currCard.Description||''"></div>
		</div>
	</div>
</template>
<script>
	import Cookies from 'js-cookie';
	export default {
		name: 'media',
		data() {
			return {
				isTou: 0,
				imgUrl: require('../../image/banner_a.png'),
				swiperOptionTop: {
					autoplay: true,
					loop: true,
					spaceBetween: 0,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				},
				swiperOptionThumbs: {
					spaceBetween: 0,
					centeredSlides: false,
					centeredSlidesBounds: false,
					slidesPerView: 4,
					touchRatio: 0.2,
					slideToClickedSlide: true,
					autoplay: {
						// 设置为自动轮播
						delay: 4000,
						disableOnInteraction: false
					}
				},
				isTab: 0,
				cardList: [],
				currCard: {}
			};
		},
		watch: {
			currCard(val) {
				this.imgUrl = val.PcPictureUrls[0];
			}
		},
		mounted() {
			this.GetCardList();
		},
		methods: {
			imgItem(item, index) {
				console.log(item);
				this.imgUrl = item;
				this.isTou = index;
			},
			onTab(index) {
				this.currCard = this.cardList[index];
				if(this.currCard.Info){
					this.currCard.Info = this.currCard.Info.replace(new RegExp('\n',('gm')),'<br/>');
				}
			},
			vipPay() {
				// 缓存数据登录后跳转
				// this.$store.state.user.orderCard = this.currCard;
				sessionStorage.setItem('orderCardObj',JSON.stringify(this.currCard))
				this.$router.push('/vipPay');
			},
			// 获取卡
			GetCardList: function() {
				var that = this;
				const loading = this.$loading({
				          lock: true,
				          text: 'Loading',
				          spinner: 'el-icon-loading',
				          background: 'rgba(0, 0, 0, 0.7)'
				        });
				that.$api.HtppRequest(
					'Card',
					'GET', {},
					function(res) {
						console.log('获取卡');
						console.log(res);
						if (res.code === 0) {
							var list = res.data;
							var newList = [];
							for (var i = 0; i < list.length; i++) {
								list[i].Price = parseFloat(list[i].Price).toFixed(2);
								newList.push(list[i]);
								if (i === 0) {
									that.currCard = list[i];
									if(that.currCard.Info){
										that.currCard.Info = that.currCard.Info.replace(new RegExp('\n',('gm')),'<br/>');
									}
								}
							}
							that.cardList = newList;
							// that.$nextTick(() => {
							// 	const swiperTop = that.$refs.swiperTop.$el.swiper;
							// 	const swiperThumbs = that.$refs.swiperThumbs.$el.swiper;
							// 	swiperTop.controller.control = swiperThumbs;
							// 	swiperThumbs.controller.control = swiperTop;
							// });
						}
						 loading.close();
					},
					function(res) {
						 loading.close();
					}
				);
			}
		}
	};
</script>
<style lang="scss" scoped>
	/deep/.swiper-button-next,
	/deep/.swiper-button-prev {
		opacity: 0.4;
		zoom: 0.6;
	}

	/deep/.swiper-button-next:hover,
	/deep/.swiper-button-prev:hover {
		opacity: 1;
	}

	.bai_txt /deep/img {
		display: block;
		max-width: 100%;
	}

	.bai_txt {
		padding: 30px 0;
		font-size: 16px;
		color: #666666;
		line-height: 26px;
	}

	.bai_b h6 {
		background-color: #e5edf1;
		padding: 18px;
		font-size: 16px;
		color: #005371;
		font-weight: normal;
	}

	.bai_b {
		background-color: #fff;
		border-radius: 6px;
		padding: 20px 30px;
		margin-top: 20px;
	}

	.head_ytxt {
		font-size: 14px;
		color: #666666;
	}

	.hea_an img {
		width: 20px;
		height: 20px;
		display: block;
		margin-right: 10px;
	}

	.hea_an:last-child {
		background-color: #005371;
		margin-left: 40px !important;
	}

	.hea_an {
		width: 230px;
		height: 46px;
		border-radius: 4px;
		background-color: #ff9f08;
		font-size: 14px;
		color: #fff;
		text-align: center;
		line-height: 46px;
		margin: 20px 0;
	}

	.head_red {
		color: #ff0808;
		font-size: 14px;
		padding-left: 10px;
	}

	.head_yqian h6 {
		margin-left: 25px;
		color: #ff7c04;
		font-size: 26px;
	}

	.head_yqian h6 span {
		text-decoration: line-through;
	}

	.head_yqian span {
		font-size: 14px !important;
		color: #ff7c04;
		font-weight: normal;
	}

	.head_yqian {
		margin: 20px 0;
		padding: 20px 10px;
		background-color: #fff3e6;
	}

	
	.head_tab p.on {
		color: #fff;
		border-color: #fff;
		background: -webkit-linear-gradient(to right, #ffb019, #ff7c04);
		background: -o-linear-gradient(to right, #ffb019, #ff7c04);
		background: -moz-linear-gradient(to right, #ffb019, #ff7c04);
		background: linear-gradient(to right, #ffb019, #ff7c04);
	}

	.head_tab p.on:hover {
		opacity: 1;
	}

	.head_tab p {
		margin-bottom: 20px;
		padding: 0 10px;
		min-width: 120px;
		font-size: 14px;
		color: #333333;
		text-align: center;
		line-height: 34px;
		height: 34px;
		border: solid 1px #cccccc;
		border-radius: 4px;
		margin-right: 20px;
		cursor: pointer;
	}

	.head_tab p:hover {
		opacity: 0.7;
	}

	.head_you {
		width: calc(100% - 428px);
	}

	.head_ddimg img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.head_ddimg.on {
		border-color: #3f3f3f;
	}

	.head_ddimg {
		width: 85px;
		height: 60px;
		overflow: hidden;
		background: url(../../image/nob.png) no-repeat left top;
		background-size: 100% 100%;
		border: solid 2px transparent;
	}

	.head_dl {
		width: calc(100% - 30px);
	}

	.head_down>img:last-child {
		transform: rotate(-180deg);
	}

	.head_down>img {
		display: block;
		width: 9px;
		height: 16px;
	}

	.head_down {
		margin-top: 20px;
	}

	.head_img img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.head_img {
		width: 100%;
		height: 280px;
		background: url(../../image/nob.png) no-repeat left top;
		background-size: 100% 100%;
	}

	.head_left {
		width: 400px;
	}

	.head_bai {
		background-color: #fff;
		padding: 30px;
	}

	* {
		box-sizing: border-box;
	}

	.vip_page {
		padding: 20px 0;
	}

	.aa li {
		opacity: 0.4;
	}

	.aa li.ona {
		opacity: 1;
	}
</style>
